export const SubmitStatuses = {
  UNINITIALIZED: 'UNINITIALIZED',
  SUBMITTING: 'SUBMITTING',
  SUBMITTED: 'SUBMITTED',
  FAILED: 'FAILED',
} as const;

export type SubmitStatus = ObjectValues<typeof SubmitStatuses>;
